import React from 'react';
import {
  Avatar,
  Box,
  Chip,
  Divider,
  Drawer,
  IconButton,
  Stack,
  Typography,
} from '@mui/material';
import { Close as CloseIcon } from '@mui/icons-material';

const DRAWER_WIDTH = 340;

const roleColor = {
  admin:      'error',
  faculty:    'primary',
  cbcfaculty: 'secondary',
  student:    'default',
};

const Field = ({ label, value }) => (
  <Box>
    <Typography variant="caption" color="text.secondary" display="block">{label}</Typography>
    <Typography variant="body2">{value || '—'}</Typography>
  </Box>
);


export default function UserProfileDrawer({ open, user, onClose }) {
  if (!user) return null;

  const initials = (user.name || '?')
    .split(' ')
    .map((w) => w[0])
    .slice(0, 2)
    .join('')
    .toUpperCase();

  const fmtDate = (d) => d ? new Date(d).toLocaleString() : '—';

  return (
    <Drawer
      anchor="right"
      open={open}
      onClose={onClose}
      PaperProps={{ sx: { width: DRAWER_WIDTH } }}
    >
      {/* Header */}
      <Box sx={{ p: 2, display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <Typography variant="h6">User Profile</Typography>
        <IconButton size="small" onClick={onClose} aria-label="close">
          <CloseIcon fontSize="small" />
        </IconButton>
      </Box>

      <Divider />

      {/* Avatar + name */}
      <Box sx={{ p: 3, textAlign: 'center' }}>
        <Avatar
          src={user.profilePic || undefined}
          sx={{ width: 72, height: 72, mx: 'auto', mb: 1, fontSize: '1.5rem' }}
        >
          {!user.profilePic && initials}
        </Avatar>
        <Typography variant="h6">{user.name}</Typography>
        <Typography variant="body2" color="text.secondary">{user.email}</Typography>
        <Stack direction="row" spacing={1} justifyContent="center" mt={1}>
          <Chip label={user.role} size="small" color={roleColor[user.role] || 'default'} />
          <Chip
            label={user.status || 'active'}
            size="small"
            color={user.status === 'disabled' ? 'default' : 'success'}
            variant={user.status === 'disabled' ? 'outlined' : 'filled'}
          />
        </Stack>
      </Box>

      <Divider />

      {/* Details */}
      <Stack spacing={2} sx={{ p: 3 }}>
        <Field label="College"           value={user.college} />
        <Field label="ID"                value={user.id} />
        <Field label="Department"        value={user.department} />
        <Field label="Batch"             value={user.batch} />
        <Field label="Branch"            value={user.branch} />
        <Field label="Year of Study"     value={user.yearOfStudy} />
        <Field label="Section"           value={user.section} />
        <Field label="LeetCode Username" value={user.leetcodeUsername} />
        <Field label="GitHub Username"   value={user.githubUsername} />
        <Divider />
        <Field label="Last Login"        value={fmtDate(user.lastLogin)} />
        <Field label="Created At"        value={fmtDate(user.createdAt)} />
        <Field label="Updated At"        value={fmtDate(user.updatedAt)} />
      </Stack>
    </Drawer>
  );
}
